import React from 'react';
import Hero from '../components/Hero/Hero';
import CategorySlider from '../components/CategorySlider/CategorySlider';
import PromoBanner from '../components/PromoBanner/PromoBanner';
import FeaturedRestaurants from '../components/FeaturedRestaurants/FeaturedRestaurants';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import { Testimonials, Stats } from '../components/Testimonials/Testimonials';
import FAQ from '../components/FAQ/FAQ';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  const handleCategorySelect = (categoryName) => {
    navigate(`/menu?category=${encodeURIComponent(categoryName)}`);
  };

  return (
    <div style={{ width: '100%', overflowX: 'hidden' }}>
      <Hero />
      <PromoBanner />
      <CategorySlider onSelectCategory={handleCategorySelect} />
      <FeaturedRestaurants />
      <HowItWorks />
      <Testimonials />
      <Stats />
      <FAQ />
    </div>
  );
};

export default Home;
